import React from "react";

import { Col, Row } from "react-bootstrap";

interface SectionHeaderComponentProps {
  title: string;
  eyebrow?: string;
  description?: string;
}

const SectionHeader: React.FC<SectionHeaderComponentProps> = ({
  title,
  eyebrow = "",
  description = "",
}) => (
  <Row className="mb-2">
    <Col xs={12}>
      {eyebrow ? <span className="sectionEyebrow">{eyebrow}</span> : null}

      <h2 className="sectionHeader">{title}</h2>

      {description ? <p className="sectionDescription">{description}</p> : null}
    </Col>
  </Row>
);

export default SectionHeader;
